import React, { useCallback, useState } from 'react'
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import {
    InputLabel,
    MenuItem,
    Select,
    TextField,
    DialogContent,
    Avatar,
    IconButton,
    Button,
    Switch,
    FormControlLabel,
    Menu,
    Tooltip,
    Box
} from '@mui/material';
import "./MyProfile.css";
import { useDispatch, useSelector } from "react-redux";
import { changeStatus, updatePhoto, updateMediaPersistence, deletePhoto } from "../../store/controlPanelThunks.js";
import { useTranslation } from 'react-i18next';
import { statusList } from '../../../../data/statusOptions.js';
import { getInitialAvatarJSX, deriveNames } from '../../../../utils/stringUtils.js';
import LanguageSelect from '../../../../components/LanguageSelect/LanguageSelect.jsx';
import { addNotification } from '../../../Notifications/store/notificationsSlice.js';
import { useRef } from 'react';
import ActionConfirmation from '../../../../components/ActionConfirmation.js';
import IOSSwitch from '../../../../components/IOSSwitch.js';
import { setOpenModal } from '../../store/controlPanelSlice.js';
import NotificationBuilder from '../../../Notifications/utils/NotificationBuilder.js';
const iconPath = (iconName) =>
    require(`../../../../assets/status_icon/${iconName}.png`);

export default function ProfileComponent({ localAvatar }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [userStatusEnabled, setUserStatusEnabled] = useState(true);
    const fileInputRef = useRef(null);
    // Reusable styles for icons
    const muiIconStyle = { marginRight: "0.5rem" };
    const imageIconStyle = { width: "1.5rem", marginRight: "0.5rem" };
    const { firstName, lastName } = deriveNames(localAvatar);
    const hasRealPhoto = !!localAvatar?.urlphoto && localAvatar.urlphoto !== 'Avatar.png';
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false); // State for delete confirmation modal
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuWidth, setMenuWidth] = useState(null);
    const { isGuest } = useSelector((state) => state.auth);
    const handleStatusChange = useCallback(async (event) => {
        const newStatus = event.target.value;
        dispatch(changeStatus({
            body: {
                status: newStatus
            }
        }));
    }, [dispatch]);
    const handleMenuOpen = (e) => {
        setAnchorEl(e.currentTarget);
        setMenuWidth(e.currentTarget.offsetWidth);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const onChangePhoto = async (event) => {
        try {
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                const notification = NotificationBuilder.error()
                    .withHeader('TAILLE_MAXIMALE_FICHIER', true)
                    .build()
                dispatch(addNotification(notification));

                return;
            }

            const allowedTypes = [
                "image/jpeg",
                "image/jpg",
                "image/png",
            ];

            // Vérifier type MIME
            if (!allowedTypes.includes(file.type)) {
                const notification = NotificationBuilder.error()
                    .withHeader('TYPE_INVALIDE', true)
                    .build()
                dispatch(addNotification(notification));

                return;
            }
            const formData = new FormData();
            formData.append('file', file);

            const res = await dispatch(updatePhoto({
                body: formData,
                params: [{ userId: localAvatar.id }]
            })).unwrap();

            if (res?.message?.url_photo && isGuest) {
                localStorage.setItem('avatarImage', res?.message?.url_photo);
            }


            // Reset input field after successful upload
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

        } catch (error) {
            console.error("Upload failed:", error);
            const notification = NotificationBuilder.error()
                    .withHeader('upload_error', true)
                    .withLucideIcon('cloud-off')
                    .build()
            dispatch(addNotification(notification));
        }
    };

    const handleDeletePhoto = (e) => {

        e.preventDefault(); // Prevent default button behavior
        e.stopPropagation(); // Prevent triggering the background selection
        setConfirmDeleteOpen(true);
    };
    const handleConfirmDelete = async () => {
        await dispatch(deletePhoto({
            body: null,
            params: [{ userId: localAvatar.id }]
        })).unwrap();
        setConfirmDeleteOpen(false);
    };

    const handleOpenVideo = () => {
        dispatch(setOpenModal("take_photo"));
    }

    const handlePhotoClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    return (
        <>
            <DialogContent className='dialog-content-scroll'>
                <div className="profil-grid">
                    <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", marginRight: "1.875rem", gap: "1.5rem" }}>
                        <div className="avatar-hover-area">
                            {hasRealPhoto ? (
                                <>
                                    <Avatar
                                        className="avatar-profil"
                                        alt="User Avatar"
                                        src={localAvatar?.urlphoto}
                                        sx={{
                                            width: "8rem",
                                            height: "8rem",
                                            borderRadius: "50%",
                                            marginTop: "1.25rem",
                                        }}
                                    />
                                    {/* Corbeille uniquement si hasRealPhoto */}
                                    <IconButton
                                        onClick={(e) => handleDeletePhoto(e)}
                                        sx={{
                                            position: "absolute",
                                            top: "1.25rem",
                                            right: "0.9375rem",
                                            backgroundColor: "rgba(255,0,0,0.8)",
                                            color: "#fff",
                                            width: "1.625rem",
                                            height: "1.625rem",
                                            padding: 0,
                                            minWidth: 0,
                                            "&:hover": { backgroundColor: "rgba(255,0,0,0.8)" },
                                            opacity: 0,
                                            transition: "opacity 0.2s",
                                            zIndex: 1,
                                        }}
                                        className="delete-avatar-btn"
                                    >
                                        <span className="material-symbols-outlined">delete</span>
                                    </IconButton>
                                </>

                            ) : (
                                getInitialAvatarJSX(firstName, lastName, {
                                    className: "avatar-profil",
                                    alt: "User Avatar",
                                    style: {
                                        width: "8rem",
                                        height: "8rem",
                                        borderRadius: "50%",
                                        marginTop: "1.25rem",
                                        objectFit: "cover",
                                    },
                                })
                            )}
                        </div>
                        {/* Main Button */}
                        <Button
                            className="camera-button"
                            onClick={handleMenuOpen}
                            sx={{
                                textTransform: 'none',
                                padding: 0,

                            }}
                        >
                            {t("change_photo")}
                        </Button>

                        {/* Dropdown Menu */}
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            PaperProps={{
                                sx: {
                                    width: menuWidth,   // 👈 match button width
                                    maxWidth: menuWidth,
                                    display: "inline-flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.75rem",
                                    borderRadius: "0.5rem",
                                    border: "1.5px solid #CDD5DF",
                                    background: "#FFF",
                                    boxShadow:
                                        "0 4px 6px -1px rgba(10, 13, 18, 0.10), 0 2px 4px -2px rgba(10, 13, 18, 0.06)",
                                    overflow: "hidden",
                                },
                            }}
                            MenuListProps={{
                                sx: {
                                    width: "100%",
                                    padding: "0rem",
                                    "& .MuiMenuItem-root": {
                                        px: "0.75rem",

                                        borderRadius: "0.375rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        minWidth: 0,

                                        "& .item-text": {
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            flexGrow: 1,
                                            minWidth: 0,
                                            color: "var(--black, #0C0C0C)",
                                            fontFamily: "Poppins",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            // takes remaining space
                                        },
                                        "&:hover": {
                                            background: "#F2F4F7",
                                        },
                                    },
                                },
                            }}
                        >

                            {/* Take Photo */}
                            <MenuItem onClick={handleOpenVideo}>
                                <Tooltip
                                    title={t("take_photo")}
                                    placement="top"
                                    PopperProps={{
                                        container: document.querySelector('.MuiDialog-root'),
                                    }}
                                    slotProps={{
                                        popper: {
                                            sx: { zIndex: 10012 },
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.5rem",
                                            width: "100%",        // important: take full MenuItem width
                                            minWidth: 0,          // important: allow ellipsis
                                        }}
                                    >
                                        <span class="material-symbols-outlined">
                                            photo_camera
                                        </span>
                                        <span class="item-text">
                                            {t("take_photo")}
                                        </span>
                                    </Box>
                                </Tooltip>
                            </MenuItem>
                            {/* Choose Image */}
                            <MenuItem onClick={handlePhotoClick}>
                                <Tooltip
                                    title={t("edit_photo")}
                                    placement="bottom"
                                    PopperProps={{
                                        container: document.querySelector('.MuiDialog-root'),
                                    }}
                                    slotProps={{
                                        popper: {
                                            sx: { zIndex: 10012 },
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.5rem",
                                            width: "100%",        // important: take full MenuItem width
                                            minWidth: 0,          // important: allow ellipsis
                                        }}
                                    >
                                        <span class="material-symbols-outlined">
                                            filter
                                        </span>
                                        <span class="item-text">{t("edit_photo")}</span>
                                    </Box>
                                </Tooltip>
                            </MenuItem>
                        </Menu>

                        {/* Hidden file input */}
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            ref={fileInputRef}
                            onChange={onChangePhoto}
                        />

                    </div>
                    <div>
                        <InputLabel id="language-label" sx={{ fontSize: "1.25rem" }}>
                            {t("name")}
                        </InputLabel>
                        <TextField
                            margin="dense"
                            id="name"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={
                                localAvatar?.is_guest
                                    ? localAvatar?.display_name || localAvatar?.username
                                    : localAvatar?.name
                            }
                            InputProps={{ readOnly: true }}
                            sx={{ marginBottom: "1.125rem" }}
                        />
                        {localAvatar && !localAvatar.is_guest && (
                            <>
                                <InputLabel id="language-label" sx={{ fontSize: "1.25rem" }}>
                                    {t("email")}
                                </InputLabel>
                                <TextField
                                    margin="dense"
                                    id="email"
                                    type="email"
                                    fullWidth
                                    variant="standard"
                                    value={localAvatar.email}
                                    InputProps={{ readOnly: true }}
                                    sx={{ marginBottom: "1.125rem" }}
                                />
                            </>
                        )}
                        {userStatusEnabled && (
                            <>
                                <InputLabel id="status-label" sx={{ fontSize: "1.25rem", marginBottom: "0.625rem" }}>
                                    {t("status")}
                                </InputLabel>
                                <Select
                                    labelId="status-label"
                                    id="status-select"
                                    value={localAvatar?.user_status || "0"}
                                    onChange={handleStatusChange}
                                    sx={{
                                        width: "100%",
                                        "& .MuiSelect-select": {
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: "unset",
                                            padding: "0.5rem",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            minHeight: "15%",
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 190,
                                                overflowY: "auto",
                                            },
                                        },
                                    }}
                                >
                                    {statusList.map((status) => (
                                        <MenuItem key={status.value} value={status.value}>
                                            {status.type === 'mui' ? (
                                                <status.IconComponent sx={{ ...muiIconStyle, color: status.color }} />
                                            ) : (
                                                <img
                                                    src={iconPath(status.iconName)}
                                                    alt={status.labelKey}
                                                    style={imageIconStyle}
                                                />
                                            )}
                                            {t(status.labelKey)}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <InputLabel id="status-label" sx={{ fontSize: "1.25rem", marginBottom: "0.625rem", marginTop: "0.625rem" }}>
                                    {t("language")}
                                </InputLabel>
                                <LanguageSelect

                                />
                                <FormControlLabel
                                    control={
                                        <IOSSwitch
                                            colorvariant="standard"
                                            checked={localAvatar?.media_persistence === 1}
                                            onChange={(e) => {
                                                dispatch(updateMediaPersistence({
                                                    body: {
                                                        media_persistence: e.target.checked ? 1 : 0
                                                    }
                                                }));
                                            }}
                                        />
                                    }
                                    label={t("media_persistence")}
                                    sx={{ marginTop: "0.625rem", marginLeft: "1px", display: "flex", alignItems: "center", gap: "0.625rem" }}
                                />
                            </>
                        )}
                    </div>
                </div>
            </DialogContent>


            {/* Delete Background Confirmation Modal */}
            <ActionConfirmation
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
                title={t("avatar_deletion")}
                msg={t("delete_image_confirmation_dialog_message")}
                cancelText={t("cancel")}
                confirmText={t("delete")}
                variant="destructive"
                onConfirm={handleConfirmDelete}
            />
        </>
    );
}